import products from "../../api/products";
import statusHistory from "./StatusHistory";
import contracts from "./Contracts";

const getDefaultState = () => {
  return {
    products: [],
    productsLoading: true,
    productsLoaded: false,
    productsError: false,

    productNumbers: [],
    fetchProductNumbersLoading: false,
    fetchProductNumbersError: false,
    fetchProductNumbersErrorResponse: null,

    productAllTariffs: [],
    productAllTariffsLoading: false,
    selectedTariffPromos: [],
    productAllPromos: [],
    currentProduct: {},
    currentProductLoading: {},
    currentVoipSite: {},
    productAddons: [],
    productChildren: [],
    productChildrenLoading: false,
    voipSiteAddons: [],
    telcoAddons: [],
    changeTariffLoading: false,
    createProductOpen: false,
    openEscalations: [],
    changeTariffSnack: {
      show: false,
      text: '',
      type: '', // success, error, info
    },
    statuses: [],
    statusesLoading: false,
    createProductLoading: false,
    statusUpdateLoading: false,
    telcoProvisioning: {
      line_address: {
        line_one: "",
        line_two: "",
        city: "",
        county: "",
        country: "",
        post_code: "",
      },
      line_address_category: "",
      line_supplier: "",
      broadband_supplier: "",
      line_number: "",
      order_type: ""
    },
    telcoProvisioningLoading: false,

    telcoModems: [],
    telcoModemsLoading: false,
    telcoModemAddress: {
      line_one: '',
      line_two: '',
      city: '',
      post_code: '',
      country: '',
    },
    telcoModemUpdate: {},
    telcoModemUpdateLoading: false,
    isEDBEmailSending: false,
    retentionProducts: [],
    retentionProductsLoading: false,

    productAuditHistory: {
      logs: [],
      config: {
        paginationCount: 0,
        paginationLimit: 10,
        paginationPage: 1,
      }
    },
    productAuditHistoryLoading: false,
    productAuditHistoryError: false,
    productAuditHistoryErrorResponse: null,

    deleteProductChildLoading: false,
    deleteProductChildError: false,
    deleteProductChildErrorResponse: null,

    updateSupplierLoading: false,
    updateSupplierError: false,
    updateSupplierErrorResponse: null,
  };
};

const state = getDefaultState();

const mutations = {
  setTelcoModemData(state, payload){
    state.telcoModemAddress = {
      line_one: payload.line_one,
      line_two: payload.line_two,
      city: payload.city,
      post_code: payload.post_code,
      country: payload.country,
      county: payload.county,
    };
  },
  setCreateProductOpen(state, payload){ state.createProductOpen = payload; },
  setTelcoModemDataLoading(state, payload){ state.telcoModemDataLoading = payload; },
  setCurrentProductModemDeliveryAddress(state, payload) {
    state.telcoModemAddress = payload;
  },
  setTelcoModemUpdate(state, payload){
    state.telcoModemUpdate = payload;
    state.telcoModemUpdateLoading = false;
  },
  setTelcoModemUpdateLoading(state, payload){ state.telcoModemUpdateLoading = payload; },
  setTelcoModems(state, payload){
    state.telcoModems = payload;
    state.telcoModemsLoading = false;
  },
  setTelcoModemsLoading(state, payload){ state.telcoModemsLoading = payload; },
  setIsEDBEmailSending(state, payload){ state.isEDBEmailSending = payload; },
  setStatuses(state, payload){
    state.statuses = payload;
    state.statusesLoading = false;
  },
  setStatusesLoading(state, payload){
    state.statusesLoading = payload;
  },
  createProductLoading(state, payload){
    state.createProductLoading = payload;
  },
  setStatusUpdateLoading(state, payload){
    state.statusUpdateLoading = payload;
  },
  setChangeTariffLoading(state, payload) {
    state.changeTariffLoading = payload;
  },
  setChangeTariffSnack(state, payload) {
    state.changeTariffSnack = payload;
  },
  setProducts(state, payload) {
    state.products = payload;
    state.productsLoading = false;
    state.productsLoaded = true;
    state.productsError = false;
  },

  FETCH_PRODUCT_NUMBERS_BEGIN(state) {
    state.fetchProductNumbersLoading = true;
    state.fetchProductNumbersError = false;
    state.fetchProductNumbersErrorResponse = null;
  },
  FETCH_PRODUCT_NUMBERS_SUCCESS(state, payload) {
    state.fetchProductNumbersLoading = false;
    state.productNumbers = payload;
  },
  FETCH_PRODUCT_NUMBERS_ERROR(state, err) {
    state.fetchProductNumbersLoading = false;
    state.fetchProductNumbersError = true;
    state.fetchProductNumbersErrorResponse = err;
  },

  setTelcoAddons(state, payload) {
    state.telcoAddons = payload;
  },
  setAllAddons(state, payload) {
    state.productAddons = payload.filter(e=>e.product_kind.toLowerCase()==='voipseat');
    state.voipSiteAddons = payload.filter(e=>e.product_kind.toLowerCase()==='voip');
  },
  setSelectedTariffPromos(state, payload) {
    state.selectedTariffPromos = payload;
  },
  setAllTariffsLoading(state, payload) {
    state.productAllTariffsLoading = payload;
  },
  setAllTariffs(state, payload) {
    state.productAllTariffs = payload;
  },
  setAllPromos(state, payload) {
    state.productAllPromos = payload;
  },
  setCurrentProduct(state, payload) {
    state.currentProduct = payload;
    state.currentProductLoading = false;
  },
  setCurrentProductLoading(state, payload) {
    state.currentProductLoading = payload;
  },
  setOpenEscalations(state, payload) { state.openEscalations = payload; },
  setCurrentProductDeliveryAddress(state, payload) {
    state.currentProduct.delivery_address = JSON.parse(JSON.stringify(payload));
  },
  setProductChildren(state, payload) {
    state.productChildren = payload;
  },
  setProductChildrenLoading(state, payload) {
    state.productChildrenLoading = payload;
  },
  setCurrentVoipSite(state, payload) {
    state.currentVoipSite = payload;
  },
  setTelcoProvisioning(state, payload) {
    state.telcoProvisioning.line_address.line_one = payload.line_address.line_one;
    state.telcoProvisioning.line_address.line_two = payload.line_address.line_two;
    state.telcoProvisioning.line_address.city = payload.line_address.city;
    state.telcoProvisioning.line_address.county = payload.line_address.county;
    state.telcoProvisioning.line_address.country = payload.line_address.country;
    state.telcoProvisioning.line_address.post_code = payload.line_address.post_code;
    state.telcoProvisioning.line_address_category = payload.line_address_category;
    state.telcoProvisioning.line_supplier = payload.line_supplier;
    state.telcoProvisioning.broadband_supplier = payload.broadband_supplier;
    state.telcoProvisioning.line_number = payload.line_number;
    state.telcoProvisioning.order_type = payload.order_type;
    state.telcoProvisioning.expected_live_date = payload.expected_live_date;
  },
  setTelcoProvisioningLoading(state, payload) {
    state.telcoProvisioningLoading = payload;
  },
  setRetentionProducts(state, payload) {
    state.retentionProducts = payload;
  },
  setRetentionProductsLoading(state, payload) {
    state.retentionProductsLoading = payload;
  },
  UPDATE_FAULT_APPOINTMENT(state,data){
    state.currentProduct.product_details.fault_appt_preferred_window = data.fault_appt_preferred_window;
    state.currentProduct.product_details.fault_appt_date = data.fault_appt_date;
    state.currentProduct.product_details.fault_appt_ref = data.fault_appt_ref;
  },

  FETCH_PRODUCT_AUDIT_BEGIN(state) {
    state.productAuditHistoryLoading = true;
    state.productAuditHistoryError = false;
    state.productAuditHistoryErrorResponse = null;
  },

  FETCH_PRODUCT_AUDIT_SUCCESS(state, payload) {
    state.productAuditHistory.logs = payload.data;
    state.productAuditHistory.config.paginationCount = parseInt(payload.headers['pagination-count']);
    state.productAuditHistoryLoading = false;
  },

  FETCH_PRODUCT_AUDIT_ERROR(state, err) {
    state.productAuditHistoryLoading = false;
    state.productAuditHistoryError = true;
    state.productAuditHistoryErrorResponse = err;
  },

  UPDATE_PRODUCT_AUDIT_PAGINATION(state, payload) {
    state.productAuditHistory.config.paginationLimit = payload.itemsPerPage;
    state.productAuditHistory.config.paginationPage = payload.page;
  },

  RESET_PRODUCT_AUDIT_HISTORY(state) {
    state.productAuditHistory.logs = [];
    state.productAuditHistory.config.paginationCount = 0;
    state.productAuditHistory.config.paginationLimit = 10;
    state.productAuditHistory.config.paginationPage = 1;
  },

  DELETE_PRODUCT_CHILD_BEGIN(state) {
    state.deleteProductChildLoading = true;
    state.deleteProductChildError = false;
    state.deleteProductChildErrorResponse = null;
  },

  DELETE_PRODUCT_CHILD_SUCCESS(state) {
    state.deleteProductChildLoading = false;
  },

  DELETE_PRODUCT_CHILD_ERROR(state, error) {
    state.deleteProductChildLoading = false;
    state.deleteProductChildError = true;
    state.deleteProductChildErrorResponse = error;
  },

  UPDATE_SUPPLIER_BEGIN(state) {
    state.updateSupplierLoading = true;
    state.updateSupplierError = false;
    state.updateSupplierErrorResponse = null;
  },
  UPDATE_SUPPLIER_SUCCESS(state) {
    state.updateSupplierLoading = false;
  },
  UPDATE_SUPPLIER_ERROR(state, err) {
    state.updateSupplierLoading = false;
    state.updateSupplierError = true;
    state.updateSupplierErrorResponse = err;
  },

  resetState (state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async updateMainProduct({commit},data){
    commit('setCurrentProduct', data);
  },
  async setCreateProductOpen({commit},data){
    commit('setCreateProductOpen', data);
  },
  async replaceModem({commit,dispatch},{pid,data}){
    commit('setTelcoModemUpdateLoading', true);
    try{
      let res = await products.replaceModem(pid,data);
      if(res.status===200){
        commit('setTelcoModemUpdate', res.data);
        dispatch("alerts/setAlert", {type: "success",message: "Modem ordered & invoice sent successfully!"}, { root: true });
        return true;
      }else{
        commit('setTelcoModemUpdateLoading', false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        return false;
      }
    }catch(error){
      commit('setTelcoModemUpdateLoading', false);
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
      return false;
    }
  },
  async sendEDBEmail({commit,dispatch},{p_id}){
    commit('setIsEDBEmailSending', true);
    try{
      let res = await products.sendEDBEmail(p_id);
      if(res.status!==200){
        throw res;
      }
      dispatch('alerts/setAlert', {type: 'success',message: 'EDB email sent successfully!'}, { root: true });
      return true;
    }catch(error){
      dispatch('alerts/setAlert', {type: 'error',message: error.response.data.message}, { root: true });
      return false;
    } finally {
      commit('setIsEDBEmailSending', false);
    }
  },
  async fetchTelcoModemData({commit,dispatch},pid){
    commit('setTelcoModemDataLoading', true);
    try{
      let res = await products.fetchTelcoModemData(pid);
      if(res.status===200){
        commit('setTelcoModemData', res.data);
      }else{
        commit('setTelcoModemDataLoading', false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(error){
      commit('setTelcoModemDataLoading', false);
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async fetchTelcoModems({commit,dispatch}){
    commit('setTelcoModemsLoading', true);
    try{
      let res = await products.fetchTelcoModems();
      if(res.status===200){
        commit('setTelcoModems', res.data);
      }else{
        commit('setTelcoModemsLoading', false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(error){
      commit('setTelcoModemsLoading', false);
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async fetchMainProduct({state,commit,dispatch},id){
    commit('setCurrentProductLoading', true);
    let promise = {};
    try{
      let res = await products.getProductById(id);
      promise.product = res;
      if(res.status===200){
        commit('setCurrentProduct', res.data);
        if(res.data.delivery_address) {
          commit('setTelcoModemData', res.data.delivery_address);
        }
        if(state.currentProduct.account_id!==null){
          promise.account = await dispatch('accounts/getCurrentAccountProm',state.currentProduct.account_id,{root:true});
        }
      }else{
        commit('setCurrentProductLoading', false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(error){
      commit('setCurrentProductLoading', false);
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
    return promise;
  },
  async fetchProductStatuses({ commit,dispatch }, p_id){
    commit('setStatusesLoading',true);
    try{
      let res = await products.loadProductStatuses(p_id);
      if(res.status===200){
        commit('setStatuses', res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('setStatusesLoading',false);
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
      commit('setStatusesLoading',false);
    }
  },
  async createProduct({ commit,dispatch }, {accountId, data}){
    commit('createProductLoading',true);
    try{
      let res = await products.createProduct(accountId, data);
      if(res.status===200){
        dispatch("alerts/setAlert", {type: "success",message: "Created product successfully!"}, { root: true });
        commit('createProductLoading', false);
        return res.data;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('createProductLoading', false);
        return false;
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
      commit('createProductLoading',false);
      return false;
    }
  },
  async updateProductStatuses({ commit,dispatch }, data){
    commit('setStatusUpdateLoading',true);
    try{
      let res = await products.updateProductStatuses(data);
      if(res.status===200){
        dispatch("alerts/setAlert", {type: "success",message: "Status updated successfully!"}, { root: true });
        commit('setStatusUpdateLoading', false);
        return true;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('setStatusUpdateLoading', false);
        return false;
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
      commit('setStatusUpdateLoading',false);
      return false;
    }
  },
  async getProductChildren({ commit,dispatch }, p_id){
    commit('setProductChildrenLoading',true);
    try{
      let res = await products.getProductChildren(p_id);
      if(res.status===200){
        commit('setProductChildren', res.data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
      commit('setProductChildrenLoading',false);
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  setProductChildren({ commit }, payload) {
    return new Promise(resolve=>{
      commit("setProductChildren", payload);
      resolve();
    });
  },
  getSubProductById({ commit }, id) {
    return products.getProductById(id).then(response => {
        return response.data;
      }).catch(() => {
        commit("resetState");
      });
  },
  async getProductById({ commit }, data) {
    return products.getProductById(data).then(response => {
        commit("setCurrentProduct", response.data);
        return new Promise(resolve=>{
          resolve();
        });
      }).catch(() => {
        commit("resetState");
      });
  },
  async getCurrentVoipSite({ commit,dispatch }, data) {
    try{
      let res = await products.getCurrentVoipSite(data);
      if(res.status===200){
        commit("setCurrentVoipSite", res.data);
      }else{
        commit("resetState");
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("resetState");
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async getAccountProducts({ commit }, data) {
    try{
      let res = await products.loadProducts(data);
      commit("setProducts", res.data);
    }catch(error){
      commit("resetState");
    }
  },
  async getEscalations({ commit }, pid) {
    try{
      let res = await products.loadProductsEscalation(pid);
      commit("setOpenEscalations", res.data);
    }catch(error){
      console.log("CONSOLE LOG: error");
      console.log(error.response);
    }
  },

  async fetchProductNumbers({ commit, dispatch }, data) {
    commit('FETCH_PRODUCT_NUMBERS_BEGIN');
    try{
      const res = await products.getNumbers(data);
      commit('FETCH_PRODUCT_NUMBERS_SUCCESS', res.data);
    } catch(err) {
      commit('FETCH_PRODUCT_NUMBERS_ERROR', err.response.data.message);
      dispatch("alerts/setAlert", {type: "error", message: err.response.data.message}, { root: true });
    }
  },

  async fetchTelcoAddons({ commit,dispatch },version) {
    try{
      const available = false;
      const supplier = "";
      
      let res = await products.getAllAddons(['TELCO'], version, available, supplier);
      if(res.status===200){
        commit("setTelcoAddons", res.data);
      }else{
        commit("resetState");
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("resetState");
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async getAllAddons({ commit,dispatch },{version, supplier}) {
    try{
      let res = await products.getAllAddons(['VOIP', 'VOIPSEAT'], version, false, supplier);
      if(res.status===200){
        commit("setAllAddons", res.data);
      }else{
        commit("resetState");
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("resetState");
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async getAllTariffs({ commit,dispatch },{version, supplier}) {
    commit("setAllTariffsLoading", true);
    try{
      let res = await products.getAllTariffs(version, false, supplier);
      if(res.status===200){
        commit("setAllTariffs", res.data);
      }else{
        commit("resetState");
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
      commit("setAllTariffsLoading", false);
    }catch(err){
      commit("resetState");
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      commit("setAllTariffsLoading", false);
    }
  },
  async getPromosForTariff({ commit,dispatch },id) {
    try{
      let res = await products.getPromosForTariff(id);
      if(res.status===200){
        commit("setSelectedTariffPromos", res.data);
      }else{
        commit("resetState");
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("resetState");
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async updateInstallAddress({ commit,dispatch }, { id,data }) {
    data.line_two = (data.line_two===null)?'':data.line_two;
    try{
      let res = await products.updateInstallAddress(id,data);
      if(res.status===200){
        commit("setCurrentVoipSite", res.data);
      }else{
        commit("resetState");
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("resetState");
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async updateProduct({ commit,dispatch }, { id,data,setCurrentProduct }) {
    try{
      let res = await products.updateProduct(id,data);
      if(res.status===200){
        if (setCurrentProduct) {
          commit('setCurrentProduct', res.data);
        }
        return res;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  transferNumber(_, { productId, data }) {
    return products.transferNumber(productId, data);
  },
  async createProductChildren(_, { id, data }) {
    const res = await products.createProductChildren(id, data);
    if(res.status === 200) {
      return res;
    } else {
      throw res;
    }
  },
  async updateChildProductNumber({ dispatch },{ id,number }) {
    try{
      let res = await products.updateChildProductNumber(id,number);
      if(res.status!==200){
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async updateSiteAc({dispatch},{id,data}) {
    let allCalls = [];
    if(data.mainNumber!==false){ allCalls.push(products.updateSiteNumber(id,data.mainNumber)); }
    if(data.tariff!==false){ allCalls.push(products.updateSiteTariff(id,data.tariff)); }
    if(data.cLength!==false){ allCalls.push(products.updateSiteContractLength(id,data.cLength)); }
    if(data.promo!==false){ allCalls.push(products.updateSitePromo(id,data.promo)); }
    if(data.addons!==false){ allCalls.push(products.updateAddons(id, data.addons)) }
    if(data.trial_period_length_days!==false){ allCalls.push(products.updateTrialPeriod(id, data.trial_period_length_days)) }
    if(data.trial_kind){ allCalls.push(products.updateProduct(id, { trial_kind: data.trial_kind })); }
    try{
      await Promise.all(allCalls);
      return true;
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
      return false;
    }
  },
  resetProductsState({ commit }) {
    commit("resetState");
  },
  async changeTariff({ commit,dispatch },{ id,payload }) {
    commit("setChangeTariffLoading", true);
    return products.changeTariff(id,payload).then(ret=>{
      if(ret.status===200){
        commit("setChangeTariffLoading", false);
        dispatch("alerts/setAlert", {type: "success",message: `Change tariff successful!`}, { root: true });
        return true;
      }else{
        commit("setChangeTariffLoading", false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        return false;
      }
    }).catch((err) => {
      commit("setChangeTariffLoading", false);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      return false;
    });
  },
  async deleteProductChild({commit, dispatch},id){
    commit('DELETE_PRODUCT_CHILD_BEGIN');
    try{
      let res = await products.deleteProductChild(id);
      if([200, 204].includes(res.status)){
        dispatch("alerts/setAlert", {type: "success",message: `User deleted successfully!`}, { root: true });
        commit('DELETE_PRODUCT_CHILD_SUCCESS');
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('DELETE_PRODUCT_CHILD_ERROR', res.response.data.message);
      }
    }catch(err){
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err}`}, { root: true });
      commit('DELETE_PRODUCT_CHILD_ERROR', err);
    }
  },
  async updateProductData({commit,dispatch},{id,data}){
    try{
      let res = await products.updateProduct(id,data);
      if(res.status===200){
        commit("setCurrentProduct", res.data);
        dispatch("alerts/setAlert", {type: "success",message: `Product updated successfully!`}, { root: true });
        return true;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        return false;
      }
    }catch(err){
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err}`}, { root: true });
      return false;
    }
  },
  async fetchTelcoProvisioning({commit, dispatch}, productId) {
    commit("setTelcoProvisioningLoading", true);
    try {
      const { data } = await products.loadTelcoLines(productId);
      commit("setTelcoProvisioning", data);
      commit("setTelcoProvisioningLoading", false);
    } catch(err) {
      commit("setTelcoProvisioningLoading", false);
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err.response.data.message}`}, { root: true });
    }
  },
  async fetchRetentionProducts({ commit, dispatch }, { productId, status }) {
    commit("setRetentionProductsLoading", true);
    try {
      const { data } = await products.fetchRetentionProducts(productId, status);
      commit("setRetentionProducts", data);
      commit("setRetentionProductsLoading", false);
    } catch(err) {
      commit("setRetentionProductsLoading", false);
      dispatch("alerts/setAlert", {type: "error",message: `There has been an error: ${err.response.data.message}`}, { root: true });
    }
  },

  async fetchProductAudit({commit, dispatch}, productId) {
    commit('FETCH_PRODUCT_AUDIT_BEGIN');
    try {
      const response = await products.fetchProductAudit(productId, state.productAuditHistory.config);
      commit('FETCH_PRODUCT_AUDIT_SUCCESS', response);
    } catch(err){
      commit('FETCH_PRODUCT_AUDIT_ERROR', err);
      dispatch("alerts/setAlert", {type: 'error', message: err.response.data.message}, { root: true });
    }
  },

  updateProductAuditPagination({commit, dispatch}, payload) {
    commit('UPDATE_PRODUCT_AUDIT_PAGINATION', payload.options);
    dispatch('fetchProductAudit', payload.productId)
  },

  async updateSupplier({commit, dispatch}, {product_id, supplier}) {
    commit('UPDATE_SUPPLIER_BEGIN');
    try {
      await products.updateSupplier(product_id, supplier);
      commit('UPDATE_SUPPLIER_SUCCESS');
    } catch(err) {
      commit('UPDATE_SUPPLIER_ERROR');
      let error = '';
      if (err.response.status === 400) {
        error = err.response.data.message.supplier[0];
      } else {
        error = err.response.data.message;
      }
      dispatch('alerts/setAlert', {type: 'error', message: error }, { root: true });
    }
  }
};

const titleCase = (str)=>{
  if(str===''){ return ''; }
  return str.toLowerCase().split(' ').map(function(word) {
    return word.replace(word[0], word[0].toUpperCase());
  }).join(' ');
}

const getters = {

  getCurrentProduct: (state) => state.currentProduct,
  getCurrentProductIsVoip3: state => state.currentProduct.supplier === 'VOIP3',
  getCurrentVoipSite: (state) => state.currentVoipSite,

  getTelcoModemUpdate: (state)=>{
    return state.telcoModemUpdate;
  },
  getTelcoModemsByModemDeliveryFees: (state)=>{
    let items = [];
    let itemsArr = state.telcoModems.map(e=>{return {cat:e.category,group:e.display_group}});
    let groupsArr = itemsArr.filter(i=>{return i.cat==='modem_delivery'&&(i.group!==''&&i.group!==null)});
    let groups = {};
    groupsArr.forEach(group => { groups[group.group] = []; });
    state.telcoModems.forEach(item => {
      if(item.category==='modem_delivery'){
        if(item.display_group!==''&&item.display_group!==null){
          if(groups[item.display_group]!==undefined){
            groups[item.display_group].push({value:item.id,price:item.standard_price});
          }
        }else{
          items.push({
            text: item.name,
            selectedPrice: {value:item.id,price:item.standard_price},
            prices: [{value:item.id,price:item.standard_price,text:`£${item.standard_price}`}]
          });
        }
      }
    });
    Object.keys(groups).forEach(k => {
      let group = groups[k];
      items.push({
        text: titleCase(k.replace(/_/g,' ')),
        prices: group.sort((a,b)=>{return a.price-b.price}).map(item=>{return{
          text:`£${item.price}`,
          price:item.price,
          value:item.value,
        }}),
        selectedPrice: group.sort((a,b)=>{return b.price-a.price})[0],
      });
    });
    return items;
  },
  getTelcoModemsByRouter: (state)=>{
    let items = [];
    let itemsArr = state.telcoModems.map(e=>{return {cat:e.category,group:e.display_group}});
    let groupsArr = itemsArr.filter(i=>{return i.cat==='router'&&(i.group!==''&&i.group!==null)});
    let groups = {};
    groupsArr.forEach(group => { groups[group.group] = []; });
    state.telcoModems.forEach(item => {
      if(item.category==='router' && item.standard_price !== '0.00'){
        if(item.display_group!==''&&item.display_group!==null){
          if(groups[item.display_group]!==undefined){
            groups[item.display_group].push({value:item.id,price:item.standard_price});
          }
        }else{
          items.push({
            text: item.name,
            selectedPrice: {value:item.id,price:item.standard_price},
            prices: [{value:item.id,price:item.standard_price,text:`£${item.standard_price}`}]
          });
        }
      }
    });
    Object.keys(groups).forEach(k => {
      let group = groups[k];
      items.push({
        text: titleCase(k.replace(/_/g,' ')),
        prices: group.sort((a,b)=>{return a.price-b.price}).map(item=>{return{
          text:`£${item.price}`,
          price:item.price,
          value:item.value,
        }}),
        selectedPrice: group.sort((a,b)=>{return b.price-a.price})[0],
      });
    });
    return items;
  },

  getAllProductNumbers: state => state.productNumbers.map((e)=>({
    extension: e.extension,
    id: e.id,
    non_geographic: e.non_geographic,
    translate_to_number_id: e.translate_to_number_id,
    number: e.number,
    number_range_id: e.number_range_id,
    status: e.status,
    porting_status: '',
    voip_site_id: e.voip_site_id,
    editLoading: false,
    port_kind: e.port_kind,
    number_delete_init_time: e.number_delete_init_time,
    rating: e.voip_number_pool.rating,
  })),

  allProductNumbersForSelect: state => state.productNumbers.filter(e=>!e.non_geographic).map(e=>({
    text: e.number,
    value: e.id
  })),
  getIsProductNumbersDeletionInProgress: (state, getters) => getters.getAllProductNumbers.some(number => number.number_delete_init_time),
  getProductNumberDeleted: (state, getters) => { 
    if (getters.getIsProductNumbersDeletionInProgress) {
      return getters.getAllProductNumbers.find(number => number.number_delete_init_time);
    }

    return null;
  },
  getFetchProductNumbersLoading: state => state.fetchProductNumbersLoading,
  getFetchProductNumbersError: state => state.fetchProductNumbersError,
  getFetchProductNumbersErrorResponse: state => state.fetchProductNumbersErrorResponse,

  getProductStatuses: state => {
    const removeStatus = ['void','lost','bad debt','blocked bad debt','pending cease bad debt','written off','handed over'];
    if(state.statuses && state.statuses.statuses) {
      return state.statuses.statuses
        .filter(e => !removeStatus.includes(e.toLowerCase()))
        .map((value) =>{
          return {
            text: value === "" ? "Release" : value,
            value: value
          }
      });
    }
  },
  
  telcoOrderInProgress: state => state.products.some(e => (e.product_kind.toLowerCase() === "telco" && e.status.toLowerCase() !== "doa" && !e.confirmed_date  && e.sold_date)),
  getAllTariffsList: state => state.productAllTariffs.filter(e => e.available).map(e => ({ name: `${e.product_kind.toLowerCase() === 'voipseat' ? 'VOIP' : e.product_kind} - ${ e.name }`, value: `${e.name}`, product_kind: e.product_kind })),
  getTelcoTariffs: state => {
    let tariffs = {};
    state.productAllTariffs.forEach(tar => {
      if(tar.available){
        tariffs[tar.id] = {name: tar.name,price: `£${parseFloat(tar.standard_price).toFixed(2)}`,service: tar.service}
      }
    });
    return tariffs;
  },
  getTariffs: state => state.productAllTariffs,
  getTelcoPromos: state => {
    let promos = {};
    state.productAllTariffs.forEach(tar => {
      tar.promos.forEach(pro => {
        promos[pro.id] = {name: pro.name}
      });
    });
    return promos;
  },
  getTelcoAddons: state => {
    let currentAddons = state.currentProduct.addons.map(e=>(e.addon_id));
    let addons = [];
    state.telcoAddons.forEach(add => {
      if(currentAddons.indexOf(add.id)!==-1){
        addons.push(`${add.name} - £${parseFloat(add.standard_price).toFixed(2)}`);
      }
    });
    return addons;
  },
  getAllTariffsLoading: state => state.productAllTariffsLoading,
  getRetentionProducts: state => state.retentionProducts,
  getRetentionProductsLoading: state => state.retentionProductsLoading,

  getProductAuditHistory: state => state.productAuditHistory,
  getProductAuditHistoryLoading: state => state.productAuditHistoryLoading,
  getProductAuditHistoryError: state => state.productAuditHistoryError,
  getProductAuditHistoryErrorResponse: state => state.productAuditHistoryErrorResponse,

  getDeleteProductChildLoading: state => state.deleteProductChildLoading,
  getDeleteProductChildError: state => state.deleteProductChildError,
  getDeleteProductChildErrorResponse: state => state.deleteProductChildErrorResponse,

  getUpdateSupplierLoading: state => state.updateSupplierLoading,
  getUpdateSupplierError: state => state.updateSupplierError,
  getUpdateSupplierErrorResponse: state => state.updateSupplierErrorResponse
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    statusHistory,
    contracts
  }
};
